<template>
  <section>
    <hirer-profile v-if="isHirer" />
    <referrer-profile v-else-if="isReferrer" />
    <jobseeker-profile v-else />
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import JobseekerProfile from './profiles/jobseeker-profile.vue'
import HirerProfile from '@/pages/profiles/hirer-profile.vue'
import ReferrerProfile from '@/pages/profiles/referrer-profile.vue'

export default {
  components: {
    JobseekerProfile,
    HirerProfile,
    ReferrerProfile
  },
  async mounted () {
    await this.getUser()
    await this.getJobSeekersBoard()
    this.getJobseekerProfile()
    this.getJobTags()
  },
  computed: {
    ...mapGetters('users', ['user']),
    getProfile () {
      if (!this.user) return null
      return this.user.profile
    },
    isJobseeker () {
      return this.getProfile === 'jobseeker'
    },
    isHirer () {
      return this.getProfile === 'hirer'
    },
    isReferrer () {
      return this.getProfile === 'referrer'
    }
  },
  methods: {
    ...mapActions('jobs', [
      'getJobTags'
    ]),
    ...mapActions('users', ['getUser']),
    ...mapActions('jobseekers', ['getJobSeekersBoard']),
    ...mapActions('jobseekerProfiles', ['getJobseekerProfile'])
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/profile.vue